<template>
    <div>
        <!-- ECharts图表容器 -->
        <div ref="FunnelChart" style="height: 300px;"></div>
    </div>
</template>
  
<script>
import ClueService from "~/services/SaleClues";
import echarts from 'echarts';

export default {
    props:{
        params:{
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            count_data: {
                categories: [],
                data: [],
            },
        };
    },
    created(){
        this.getData(this.searcherModel);
    },
    mounted() {
        // this.initChart();
    },
    methods: {
        getData() {
            ClueService.getRealCountSimple(this.params)
            .then(res=>{
                this.count_data = res.data;
                this.initChart(this.count_data.apply, this.count_data.leader);
            })
        },
        initChart(apply, leader) {
            const chartContainer = this.$refs.FunnelChart;
            if (!chartContainer){
                return false;
            }
            const myChart = echarts.init(chartContainer);
            const option = {
                title: [
                    {
                        text: '申请人真实性',
                        left: '34%', // 根据需要调整位置
                        top: 'bottom', // 标题显示在底部
                        textStyle: {
                            color: '#333', // 字体颜色
                            fontSize: 18, // 字体大小
                        }
                    },
                    {
                        text: '负责人真实性',
                        left: '74%', // 根据需要调整位置
                        top: 'bottom', // 标题显示在底部
                        textStyle: {
                            color: '#333', // 字体颜色
                            fontSize: 18, // 字体大小
                        }
                    }
                ],
                color: [
                    '#5470c6',
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3dac78",
                    '#C280FF',
                    '#34B7FB',
                    '#81D3F8',
                ],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    orient: 'vertical',
                    left: 'left'
                },
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        dataView: {show: true, readOnly: false},
                        saveAsImage: {show: true},
                        myRefresh: {
                            show: true,
                            title: '还原图表',
                            icon: 'path://M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512S794.77 0 512 0z m0 967.95c-243.2 0-441.95-198.75-441.95-441.95S268.75 56.05 512 56.05s441.95 198.75 441.95 441.95S755.25 967.95 512 967.95z',
                            onclick: () => {
                                this.initChart(this.count_data.apply, this.count_data.leader);
                            }
                        }
                    }
                },
                series: [
                    {
                        name: '申请人真实性',
                        type: 'pie',
                        radius: '70%',
                        center: ['40%', '50%'],
                        data: apply,
                        emphasis: {
                            itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    },
                    {
                        name: '负责人真实性',
                        type: 'pie',
                        radius: '70%',
                        center: ['80%', '50%'],
                        data: leader,
                        emphasis: {
                            itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            myChart.setOption(option);
            myChart.on('click', params => {
                if(params.data.hasOwnProperty('children')){
                    if(params.seriesIndex == 0){
                        this.initChart(params.data.children, leader);
                    }else{
                        this.initChart(apply, params.data.children);
                    }
                }
            });
        },
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/clue/echarts/SimpleChart.vue